import { ReactComponent as PlusLogo } from "../../assets/icons/PlusLogo.svg";
import {ReactComponent as BulkUploadLogo} from "../../assets/icons/BulkUploadLogo.svg";
import IconButton from "../features/common/IconButton";
import "./Style.css";

const StudentHeader = ({onClickAddStudent, onAddBulkStudent}) => {
  return (
    <>
      <div>
        <h1 className="student-header-title">
          Student Management
        </h1>
        <p className="student-header-subtitle">
          Manage student profiles, track performance, and handle bulk operations
        </p>
      </div>
      <div className="student-header-actions">
        <IconButton 
        label="Bulk Add"
        customIcon={BulkUploadLogo}
        color="gray-300"
        onClick={onAddBulkStudent}
        />
        <IconButton
          label="Add Student"
          customIcon={PlusLogo}
          color="yellow-400"
          onClick={onClickAddStudent}
        />
      </div>
    </>
  );
};
export default StudentHeader;
